import store from "store/store";

import { dismissAlertMessage, promptAlertMessage } from "store/slices/alert-slice";

import ActionEnum from "enum/action";

const serveRequestSuccess = (message: string, action?: ActionEnum) => {
	const dispatch = store.dispatch;

	dispatch(promptAlertMessage({ error: false, message: message, code: "", action: action || ActionEnum.Create }));

	setTimeout(() => {
		dispatch(dismissAlertMessage());
	}, 2000);
};

export default serveRequestSuccess;
